import AdSense from 'react-adsense';
import React, {Component } from 'react'

import { styled } from '@mui/styles';

 import { makeStyles } from 'tss-react/mui'; // if you still want to use makeStyles

import Box from '@mui/material/Box';

const useStyles = makeStyles()((theme) => ({
    AdBox: {
        width:"160px",
        height:"600px",
        background:"#eef"
      }
}));

const VerticalAds = (props) => {
    const { classes } = useStyles();

    return (<Box className={classes.AdBox}>
        
    </Box>)
}

export default (VerticalAds);